import { render, staticRenderFns } from "./fast2render.vue?vue&type=template&id=1da21544"
import script from "./fast2render.vue?vue&type=script&lang=js"
export * from "./fast2render.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports